export enum RequestStatusFilter {
    All = 'all',
    Assigned = 'assigned',
    Unassigned = 'unassigned',
    Deleted = 'deleted',
}